import store from '@/store'

export default [
  {
    path: '/teacher-profiles',
    name: 'teacher-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/teacher-profile/index.vue')
  },
  {
    path: '/teacher-profiles/create',
    name: 'teacher-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/teacher-profile/create.vue')
  },
  {
    path: '/teacher-profiles/:id',
    name: 'teacher-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/teacher-profile/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('teacherProfile/find', to.params.id)
      next()
    }
  }
]
